<template>
  <modal id="change-email-modal" :modifiers="['no-horizontal-padding']">
    <div class="change-email-modal">
      <h2 class="change-email-modal__headline">
        {{ $t("headline") }}
      </h2>
      <div class="change-password-modal__field">
        <h5 class="change-email-modal__label">
          {{ $t("current") }}
        </h5>
        <div class="change-email-modal__value">
          {{ email }}
        </div>
      </div>
      <div class="change-password-modal__field form__field">
        <label class="change-email-modal__label" for="new-email">
          {{ $t("newEmail") }}
        </label>
        <div class="form__field-container">
          <input id="new-email" class="form__input" v-model="newEmail" type="email" />
        </div>
      </div>
      <div class="change-email-modal__field form__field">
        <label class="change-email-modal__label" for="password">
          {{ $t("password") }}
        </label>
        <div class="form__field-container">
          <input id="password" class="form__input" v-model="password" type="password" />
        </div>
      </div>
      <div class="change-email-modal__footer">
        <a class="change-email-modal__cancel" @click="close">{{ $t("cancel") }}</a>
        <button class="change-email-modal__submit button" @click="submit">
          {{ $t("save") }}
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "@/shared/modal"
import events from "@/bl-events/index"

/**
 * @emits submit
 */
export default {
  name: "ChangeEmailModal",
  components: { Modal },
  props: {
    email: {
      type: String,
      required: true
    }
  },
  data: () => ({
    newEmail: "",
    password: ""
  }),
  methods: {
    close() {
      events.emit("modal:change-email-modal:close")
    },
    submit() {
      this.close()
      this.$emit("submit", {
        newEmail: this.newEmail,
        password: this.password
      })
    }
  },
  i18n: {
    messages: {
      en: {
        headline: "Change email address",
        current: "Current email address",
        newEmail: "New email address",
        password: "Password",
        cancel: "Cancel",
        save: "Change"
      },
      de: {
        headline: "E-Mail-Adresse ändern",
        current: "Aktuelle E-Mail-Adresse",
        newEmail: "Neue E-Mail-Adresse",
        password: "Passwort",
        cancel: "Abbrechen",
        save: "Ändern"
      },
      es: {
        headline: "Cambiar dirección de correo electrónico",
        current: "Dirección de correo electrónico actual",
        newEmail: "Nueva dirección de correo electrónico",
        password: "Contraseña",
        cancel: "Cancelar",
        save: "Cambiar"
      },
      pt: {
        headline: "Alterar endereço de email",
        current: "Endereço de email atual",
        newEmail: "Novo endereço de email",
        password: "Senha",
        cancel: "Cancelar",
        save: "Alterar"
      }
    }
  }
}
</script>

<style lang="scss">
.change-email-modal {
  width: 100vw;
  max-width: $x-wide-block-width;
  padding: $spacing-48 $spacing-24 $spacing-24;

  &__headline {
    @include font-style(h3);

    margin-bottom: $spacing-24;
  }

  &__field {
    margin-bottom: $spacing-24;
  }

  &__label {
    @include font-style(h4, $color: $mid-grey);

    display: block;
    margin-bottom: $spacing-8;
  }

  &__value {
    @include font-style(p);
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  &__submit {
    min-width: spacing(118px);
  }

  &__cancel {
    @include font-style(button, $color: $mid-grey);

    margin-right: $base;

    cursor: pointer;
  }
}
</style>
